angular.module('dealerware.web.filters').filter('filterAnonymizedEmail', function() {
    return function (input) {
        return /.*\@nobodyknowswhat\.tocallthis$/.test(input) ? undefined : input;
    };
});